import { Component, OnInit } from '@angular/core';
import { AppServices } from '../../services/appServices';
import { practiceSessionTemplateResponse } from '../../models/practiceSessionTemplateResponse';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { result } from '../../models/result';
import { practiceTemplateDrillResponse } from '../../models/practiceTemplateDrillResponse';

@Component({
  selector: 'app-practice-session',
  standalone: true,
  imports: [NgIf, NgFor, FormsModule],
  templateUrl: './practice-session.component.html',
  styleUrl: './practice-session.component.css'
})
export class PracticeSessionComponent implements OnInit {
  constructor(private appServices:AppServices){}

  ngOnInit(): void {
    this.searchTemplates();
    this.searchResults();
  }

  templates:practiceSessionTemplateResponse[] = [];
  resultOptions:result[] = [];
  selectedTemplate:practiceSessionTemplateResponse|null = null;
  practiceSessionId:number|null = null;

  get sortedResultOptions() {
    return [...this.resultOptions].sort((a, b) => b.sort_order - a.sort_order);
  }

  async searchTemplates() {
    let username = this.getUsername();
    if(!username) return;

    this.appServices.applicationService.showGlobalSpinner();
    this.templates = await this.appServices.templateService.searchTemplates(username);
    this.appServices.applicationService.hideGlobalSpinner();
  }

  async searchResults() {
    this.appServices.applicationService.showGlobalSpinner();
    this.resultOptions = await this.appServices.lookupService.searchResults();
    this.appServices.applicationService.hideGlobalSpinner();
  }

  async startPracticeSession() {
    let username = this.getUsername();
    if(!username || !this.selectedTemplate) return;

    this.appServices.applicationService.showGlobalSpinner();
    this.practiceSessionId = await this.appServices.practiceService.createPracticeSession(username, this.selectedTemplate.id);
    this.appServices.applicationService.hideGlobalSpinner();
  }

  getUsername():string|null {
    let username = this.appServices.authenticationService.loggedInUser?.username;
    if(username) return username;
    return null;
  }

  currentDrillIndex: number = 0;
  currentRepIndex: number = 0;

  get templateDrills() {
    return this.selectedTemplate?.template_drills ?? [];
  }

  get currentTemplateDrill() {
    if (!this.templateDrills.length) {
      return null;
    }

    if (this.currentDrillIndex < 0) {
      this.currentDrillIndex = 0;
    }

    if (this.currentDrillIndex >= this.templateDrills.length) {
      this.currentDrillIndex = this.templateDrills.length - 1;
    }

    return this.templateDrills[this.currentDrillIndex];
  }

  get currentRepNumber(): number {
    return this.currentRepIndex + 1;
  }

  get isFirstDrill(): boolean {
    return this.currentDrillIndex === 0;
  }

  get isLastDrill(): boolean {
    return this.currentDrillIndex === this.templateDrills.length - 1;
  }

  get isFirstRep(): boolean {
    return this.currentRepIndex === 0;
  }

  get isLastRep(): boolean {
    const reps = this.currentTemplateDrill?.number_of_reps ?? 0;
    return this.currentRepIndex === reps - 1;
  }

  moveToNextDrill(): void {
    if (this.currentDrillIndex < this.templateDrills.length - 1) {
      this.currentDrillIndex++;
      this.currentRepIndex = 0;
    }
  }

  moveToPreviousDrill(): void {
    if (this.currentDrillIndex > 0) {
      this.currentDrillIndex--;
      this.currentRepIndex = 0;
    }
  }

  moveToNextRep(): void {
    const reps = this.currentTemplateDrill?.number_of_reps ?? 0;

    if (this.currentRepIndex < reps - 1) {
      this.currentRepIndex++;
    } else {
      this.moveToNextDrill();
    }
  }

  moveToPreviousRep(): void {
    if (this.currentRepIndex > 0) {
      this.currentRepIndex--;
    } else if (this.currentDrillIndex > 0) {
      this.currentDrillIndex--;
      const previousDrill = this.currentTemplateDrill;
      this.currentRepIndex = Math.max((previousDrill?.number_of_reps ?? 1) - 1, 0);
    }
  }

  setSelectedTemplate(template: any): void {
    this.selectedTemplate = template;
    this.currentDrillIndex = 0;
    this.currentRepIndex = 0;
  }

  selectResult(result: any): void {
    console.log('selected result', {
      drillIndex: this.currentDrillIndex,
      repIndex: this.currentRepIndex,
      result: result
    });

    this.moveToNextRep();
  }
}